export enum visaApplicationSteps {
    'additional_details' = 'additional_details',
    'business' = 'business',
    'education' = 'education',
    'family_member' = 'family_member',
    'job_offer' = 'job_offer',
    'language' = 'language',
    'personal_info' = 'personal_info',
    'purpose' = 'purpose',
    'relative_abroad' = 'relative_abroad',
    'spouse' = 'spouse',
    'work_experience' = 'work_experience',
}

export const VisaApplicationStepName = {
    'Personal Info': 'Personal Info',
    'Additional Details': 'Additional Details',
    'Spouse/Common Law Partner': 'Spouse/Common Law Partner',
    'Family Members': 'Family Members',
    'Language Proficiency': 'Language Proficiency',
    Education: 'Education',
    'Work Experience': 'Work Experience',
    'Job Offer': 'Job Offer',
    'Relatives Abroad': 'Relatives Abroad',
    'Business Ownership': 'Business Ownership',
} as const;

export const CompleteFormNameMapping: Record<string, keyof typeof visaApplicationSteps> = {
    [VisaApplicationStepName['Additional Details']]: 'additional_details',
    [VisaApplicationStepName['Business Ownership']]: 'business',
    [VisaApplicationStepName['Education']]: 'education',
    [VisaApplicationStepName['Family Members']]: 'family_member',
    [VisaApplicationStepName['Job Offer']]: 'job_offer',
    [VisaApplicationStepName['Language Proficiency']]: 'language',
    [VisaApplicationStepName['Personal Info']]: 'personal_info',
    purpose: 'purpose',
    [VisaApplicationStepName['Relatives Abroad']]: 'relative_abroad',
    [VisaApplicationStepName['Spouse/Common Law Partner']]: 'spouse',
    [VisaApplicationStepName['Work Experience']]: 'work_experience',
};

export const BooleanValue = {
    Yes: true,
    No: false,
};

export enum BooleanValueString {
    YES = 'Yes',
    NO = 'No',
}

export enum VisaPurposes {
    BUSINESS = 'BUSINESS',
    GENERAL = 'GENERAL',
    TRAVEL = 'TRAVEL',
    STUDY = 'STUDY',
    WORK = 'WORK',
    NOPREFERENCE = 'NOPREFERENCE',
}

export enum VisaPurposeServerValues {
    BUSINESS = 'BUSINESS',
    TRAVEL = 'TRAVEL',
    STUDY = 'STUDY',
    WORK = 'WORK',
    NOPREFERENCE = 'GENERAL',
}

export const visaPreferenceOptions = [
    { label: 'Business', value: VisaPurposes.BUSINESS },
    { label: 'General', value: VisaPurposes.GENERAL },
    { label: 'Travel', value: VisaPurposes.TRAVEL },
    { label: 'Study', value: VisaPurposes.STUDY },
    { label: 'Work', value: VisaPurposes.WORK },
    { label: 'All Visas', value: VisaPurposes.GENERAL },
];

export const maritalStatusList = ['married', 'single'];
export const genderList = ['male', 'female'];

export const DriverLicenses = [
    "Don't have it",
    'A',
    'A1',
    'A2',
    'B1',
    'C',
    'C1',
    'D',
    'D1',
    'D2',
    'D3',
    'E',
];

export enum EnglishProficiencyTests {
    IELTS = 'IELTS',
    TOEFL = 'TOEFL',
    CELPIP = 'CELPIP',
    SELF_ASSESSMENT = 'Self assessment',
    CEFR = 'CEFR',
}

export enum FrenchProficiencyTests {
    TEF = 'TEF',
    TCF = 'TCF',
    SELF_ASSESSMENT = 'Self assessment',
}

export enum partnerLanguages {
    ENGLISH = 'English',
    FRENCH = 'French',
}

export enum profileLanguages {
    EN = 'EN',
    FR = 'FR',
    ES = 'ES',
}

export const PartnerEducationDuration = [1, 2, 3, 4, 5, 6];

// export enum DriverLicenses {
//   NO_LICENSE = "Don't have it",
//   A = 'A',
//   A1 = 'A1',
//   A2 = 'A2',
//   B1 = 'B1',
//   C = 'C',
//   C1 = 'C1',
//   D = 'D',
//   D1 = 'D1',
//   D2 = 'D2',
//   D3 = 'D3',
//   E = 'E',
// }

export const formStepFieldDescriptions: Record<string, { field: string; explanation: string }[]> = {
    [VisaApplicationStepName['Personal Info']]: [
        {
            field: 'visaHelpVisaPreference',
            explanation: 'visaHelpVisaPreferenceText',
        },
        {
            field: 'visaHelpCitizenship',
            explanation: 'visaHelpCitizenshipText',
        },
        {
            field: 'visaHelpFirstName',
            explanation: 'visaHelpFirstNameText',
        },
        {
            field: 'visaHelpLastName',
            explanation: 'visaHelpLastNameText',
        },
        {
            field: 'visaHelpEmail',
            explanation: 'visaHelpEmailText',
        },
        {
            field: 'visaHelpPhone',
            explanation: 'visaHelpPhoneText',
        },
    ],
    [VisaApplicationStepName['Additional Details']]: [
        {
            field: 'visaHelpGender',
            explanation: 'visaHelpGenderText',
        },
        {
            field: 'visaHelpMaritalStatus',
            explanation: 'visaHelpMaritalStatusText',
        },
        {
            field: 'visaHelpDateOfBirth',
            explanation: 'visaHelpDateOfBirthText',
        },
        {
            field: 'visaHelpCountryOfResidence',
            explanation: 'visaHelpCountryOfResidenceText',
        },
        {
            field: 'visaHelpResidenceStatus',
            explanation: 'visaHelpResidenceStatusText',
        },
        {
            field: 'visaHelpResidenceStatusSince',
            explanation: 'visaHelpResidenceStatusSinceText',
        },
        {
            field: 'visaHelpDriversLicense',
            explanation: 'visaHelpDriversLicenseText',
        },
        {
            field: 'visaHelpYearlyIncome',
            explanation: 'visaHelpYearlyIncomeText',
        },
        {
            field: 'visaHelpNetWorth',
            explanation: 'visaHelpNetWorthText',
        },
        {
            field: 'visaHelpAvailableFunds',
            explanation: 'visaHelpAvailableFundsText',
        },
        {
            field: 'visaHelpCriminalRecord',
            explanation: 'visaHelpCriminalRecordText',
        },
        {
            field: 'visaHelpTravelWithSpouse',
            explanation: 'visaHelpTravelWithSpouseText',
        },
        {
            field: 'visaHelpPastFutureVisas',
            explanation: 'visaHelpPastFutureVisasText',
        },
    ],
    [VisaApplicationStepName['Spouse/Common Law Partner']]: [],
    [VisaApplicationStepName['Family Members']]: [
        { field: 'visaHelpChildren', explanation: 'visaHelpChildrenText' },
        {
            field: 'visaHelpChildRelation',
            explanation: 'visaHelpChildRelationText',
        },
        {
            field: 'visaHelpChildDateOfBirth',
            explanation: 'visaHelpChildDateOfBirthText',
        },
        {
            field: 'visaHelpChildCountry',
            explanation: 'visaHelpChildCountryText',
        },
        {
            field: 'visaHelpChildTravelling',
            explanation: 'visaHelpChildTravellingText',
        },
        {
            field: 'visaHelpOtherFamily',
            explanation: 'visaHelpOtherFamilyText',
        },
    ],
    [VisaApplicationStepName['Language Proficiency']]: [
        {
            field: 'visaHelpNativeLanguage',
            explanation: 'visaHelpNativeLanguageText',
        },
        {
            field: 'visaHelpEnglishTestType',
            explanation: 'visaHelpEnglishTestTypeText',
        },
        {
            field: 'visaHelpListeningScore',
            explanation: 'visaHelpListeningScoreText',
        },
        {
            field: 'visaHelpReadingScore',
            explanation: 'visaHelpReadingScoreText',
        },
        {
            field: 'visaHelpWritingScore',
            explanation: 'visaHelpWritingScoreText',
        },
        {
            field: 'visaHelpSpeakingScore',
            explanation: 'visaHelpSpeakingScoreText',
        },
    ],
    [VisaApplicationStepName['Education']]: [
        {
            field: 'visaHelpEducationType',
            explanation: 'visaHelpEducationTypeText',
        },
        {
            field: 'visaHelpFieldOfStudy',
            explanation: 'visaHelpFieldOfStudyText',
        },
        {
            field: 'visaHelpEducationCountry',
            explanation: 'visaHelpEducationCountryText',
        },
        {
            field: 'visaHelpEducationStart',
            explanation: 'visaHelpEducationStartText',
        },
        {
            field: 'visaHelpEducationEnd',
            explanation: 'visaHelpEducationEndText',
        },
        {
            field: 'visaHelpOngoingEducation',
            explanation: 'visaHelpOngoingEducationText',
        },
        {
            field: 'visaHelpCompletedEducation',
            explanation: 'visaHelpCompletedEducationText',
        },
    ],
    [VisaApplicationStepName['Work Experience']]: [
        {
            field: 'visaHelpRecentWork',
            explanation: 'visaHelpRecentWorkText',
        },
        {
            field: 'visaHelpSelfEmployed',
            explanation: 'visaHelpSelfEmployedText',
        },
        {
            field: 'visaHelpCurrentEmployment',
            explanation: 'visaHelpCurrentEmploymentText',
        },
        {
            field: 'visaHelpWorkCountry',
            explanation: 'visaHelpWorkCountryText',
        },
        {
            field: 'visaHelpWorkStart',
            explanation: 'visaHelpWorkStartText',
        },
        { field: 'visaHelpWorkEnd', explanation: 'visaHelpWorkEndText' },
        {
            field: 'visaHelpFullTimePercent',
            explanation: 'visaHelpFullTimePercentText',
        },
        {
            field: 'visaHelpOccupation',
            explanation: 'visaHelpOccupationText',
        },
    ],
    [VisaApplicationStepName['Job Offer']]: [
        {
            field: 'visaHelpValidJobOffer',
            explanation: 'visaHelpValidJobOfferText',
        },
        {
            field: 'visaHelpJobCountry',
            explanation: 'visaHelpJobCountryText',
        },
        {
            field: 'visaHelpJobRegion',
            explanation: 'visaHelpJobRegionText',
        },
        {
            field: 'visaHelpHourlyWage',
            explanation: 'visaHelpHourlyWageText',
        },
        {
            field: 'visaHelpProfession',
            explanation: 'visaHelpProfessionText',
        },
    ],
    [VisaApplicationStepName['Relatives Abroad']]: [
        {
            field: 'visaHelpRelativesCanada',
            explanation: 'visaHelpRelativesCanadaText',
        },
        {
            field: 'visaHelpRelativeRelationship',
            explanation: 'visaHelpRelativeRelationshipText',
        },
        {
            field: 'visaHelpRelativeCountry',
            explanation: 'visaHelpRelativeCountryText',
        },
        {
            field: 'visaHelpRelativeRegion',
            explanation: 'visaHelpRelativeRegionText',
        },
        {
            field: 'visaHelpRelativeStatus',
            explanation: 'visaHelpRelativeStatusText',
        },
        { field: 'visaHelpRelativeAge', explanation: 'visaHelpRelativeAgeText' },
    ],
    [VisaApplicationStepName['Business Ownership']]: [
        {
            field: 'visaHelpBusinessOwnership',
            explanation: 'visaHelpBusinessOwnershipText',
        },
        {
            field: 'visaHelpBusinessCurrent',
            explanation: 'visaHelpBusinessCurrentText',
        },
        {
            field: 'visaHelpBusinessStart',
            explanation: 'visaHelpBusinessStartText',
        },
        {
            field: 'visaHelpBusinessEnd',
            explanation: 'visaHelpBusinessEndText',
        },
        {
            field: 'visaHelpBusinessCountry',
            explanation: 'visaHelpBusinessCountryText',
        },
        { field: 'visaHelpBusinessType', explanation: 'visaHelpBusinessTypeText' },
        {
            field: 'visaHelpOwnershipPercent',
            explanation: 'visaHelpOwnershipPercentText',
        },
        {
            field: 'visaHelpEmployeeCount',
            explanation: 'visaHelpEmployeeCountText',
        },
        {
            field: 'visaHelpAnnualSales',
            explanation: 'visaHelpAnnualSalesText',
        },
        { field: 'visaHelpNetProfit', explanation: 'visaHelpNetProfitText' },
        {
            field: 'visaHelpCompanyValue',
            explanation: 'visaHelpCompanyValueText',
        },
    ],
};
